// import DragM from 'dragm';
import DragM from '../_util/dragm';
import * as React from 'react';
export default class ModalTitle extends React.Component {
    constructor() {
        super(...arguments);
        this.updateTransform = transformStr => {
            // each(this.modalDom, modalDom => {
            //   modalDom.style.transform = transformStr;
            // });
            if (this.modalDom) {
                this.modalDom.style.transform = transformStr;
            }
        };
        this.setRef = el => {
            if (el) {
                this.modalDom = el.tdom.parentElement.parentElement.parentElement;
            }
        };
    }
    componentDidMount() {
        // this.modalDom = document.getElementsByClassName('sup-modal-content');
    }
    componentWillUnmount() {
        const defaultTransformStr = 'translate(0, 0)';
        // each(this.modalDom, modalDom => {
        //   modalDom.style.transform = defaultTransformStr;
        // });
        if (this.modalDom) {
            this.modalDom.style.transform = defaultTransformStr;
        }
    }
    render() {
        const { title } = this.props;
        return (<DragM ref={this.setRef} updateTransform={this.updateTransform}>
        <div>{title}</div>
      </DragM>);
    }
}
